<div *ngIf="spinner==true">
    <ngx-spinner size="medium" type="timer">
        <p style="font-size: 20px; color: white;padding-left:7%;">Loading...</p>
    </ngx-spinner>
</div>
<div class="container-fluid">
    <div class="card">
        <div class="card-header">
            <div class="d-flex justify-content-between">
                <h4 class="font-weight-bold text-dark py">CHANGE PASSWORD</h4>
            </div>

        </div>
        <div class="container" style="padding:20px;">
   
<form class="register-form" [formGroup]='createmeetingform' (ngSubmit)="postdata(createmeetingform)"
                                autocomplete="off">
                                <div class=" form-group row">
                                    <div class=" form-group col-md-6">
                                        <label for="" class="form-label">Password<span style="color:red">*</span></label>
                                        <div class="input-group"> <!-- Wrap input and eye icon in an input-group -->
                                            <input id="password" type="{{ hidePassword ? 'password' : 'text' }}" class="form-control" formControlName="password" placeholder="Password">
                                            <div class="input-group-append">
                                                <div class="input-group-text" (click)="togglePasswordVisibility()">
                                                    <img src="assets/eye.png" alt="Eye Icon" style="height:9px;">
                                                </div>
                                            </div>
                                            
                                        </div>
                                        <div style="color:red;"
                                            *ngIf=" createmeetingform.get('password').touched && createmeetingform.get('password').value==''">                                            Please fill
                                            the field</div>
                                    </div>
                                    
                                    <div class="form-group col-md-6">
                                        <label for="" class="form-label">Confirm Password<span style="color:red">*</span></label>
                                        <div class="input-group">
                                        <input type="{{ hidePassword1 ? 'password' : 'text' }}" class="form-control" formControlName="confirm_password"
                                            id="confirm_password" placeholder="Enter Confirm Password" (blur)="handleBlurChange()" />
                                            <div class="input-group-append">
                                                <div class="input-group-text" (click)="togglePasswordVisibility1()">
                                                    <img src="assets/eye.png" alt="Eye Icon" style="height:9px;">
                                                </div></div>
                                               
                                            </div>
                                            <!-- <span style="color:red;"
                                            *ngIf=" createmeetingform.get('confirm_password').touched && createmeetingform.get('confirm_password').value==''">                                                Please fill
                                            the field</span><br> -->
                                        <span *ngIf="password_wrong" style="color:red">Password is not match</span>
                                    </div>
                                </div>
<br/>
<div class="container pr-4" style="width:200px;">
    <button class="btn btn-primary" [disabled]="password_wrong || isFormEmpty()">Change Password </button>
</div>
</form>
</div>





        <div class="modal fade" id="showCM">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="card-primary">
                        <div class="card-header">
                            <h3 class="card-title" id="card_title"></h3>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="card-body">
                            <form class="register-form" [formGroup]='editmeetingform'
                                (ngSubmit)="updatedata(editmeetingform,CM_id)" autocomplete="off">
                                <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>First Name </label><span class="required "> *</span>
                                        <input readonly pInputText type="text" class="form-control" [value]="CM_name"
                                            formControlName="first_name" placeholder="Enter First Name / முதல் பெயர்">

                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label> Last Name </label><span class="required "> *</span>
                                        <input readonly pInputText type="text" class="form-control"
                                            [value]="CM_last_name" formControlName="last_name"
                                            placeholder="Enter  Last Name /கடைசி பெயர்">

                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="!editfield">

                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Email <span class="required "> *</span></label>
                                        <input readonly pInputText type="email" class="form-control" [value]="CM_email"
                                            formControlName="email" placeholder="Enter Email / மின்னஞ்சல்">

                                    </div>
                                    <div class="col-sm-6">
                                        <label>WhatsApp Number <span class="required "> *</span></label>
                                        <input pInputText type="text" class="form-control" formControlName="number"
                                            [value]="CM_number" placeholder="Enter WhatsApp Number/வாட்ஸ்அப் எண்"
                                            required readonly="readonly" />

                                    </div>
                                </div>

                                <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Academic Details<span class="required ">
                                                *</span></label>
                                        <input readonly pInputText type="text" class="form-control"
                                            [value]="CM_education" formControlName="education"
                                            placeholder="Enter Academic Details/கல்வித் தகுதி">

                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Branch <span class="required ">
                                                *</span></label>
                                        <input readonly pInputText type="email" class="form-control" [value]="CM_branch"
                                            formControlName="branch" placeholder="Enter Branch/கிளை">

                                    </div>
                                </div>


                                <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>District <span class="required ">
                                                *</span></label><br>
                                        <input readonly pInputText type="text" class="form-control"
                                            [value]="CM_district" formControlName="district"
                                            placeholder="Enter District / மாவட்டம்" required>

                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Constituency <span class="required ">
                                                *</span></label>
                                        <input readonly pInputText type="text" class="form-control"
                                            [value]="CM_constituency" formControlName="constituency"
                                            placeholder="Enter Constituency / தொகுதி">
                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Area of Expertise <span class="required ">
                                                *</span></label>
                                        <input readonly [value]="CM_area" pInputText type="text" class="form-control"
                                            formControlName="area"
                                            placeholder="Enter Area of Expertise/நிபுணத்துவப் பகுதி" required>
                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Courses Volunteering<span class="required ">
                                                *</span></label>
                                        <input readonly pInputText type="text" class="form-control" [value]="CM_courses"
                                            formControlName="courses"
                                            placeholder="Enter Courses Volunteering/படிப்புகள் தன்னார்வத் தொண்டு ">
                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Status <span class="required "> *</span></label>
                                        <input readonly [value]="CM_status" pInputText type="text" class="form-control"
                                            formControlName="status" placeholder="Enter Status"
                                            required>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6 mb-3 mb-sm-0" *ngIf="CM_image !=='' && !editfield">
                                        <label>Image <span class="required "> *</span></label>
                                        <img src="https://redmindtechnologies.com/dmk_php-dhanasekar/{{CM_image}}"
                                            style="width:100px;height:100px;display:block" />

                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>First Name / முதல் பெயர்</label><span class="required "> *</span>
                                        <input pInputText type="text" class="form-control" [value]="CM_name"
                                            formControlName="first_name" placeholder="Enter First Name / முதல் பெயர்">

                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label> Last Name /கடைசி பெயர்</label><span class="required "> *</span>
                                        <input pInputText type="text" class="form-control" [value]="CM_last_name"
                                            formControlName="last_name" placeholder="Enter  Last Name /கடைசி பெயர்">

                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="editfield">

                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Email / மின்னஞ்சல்<span class="required "> *</span></label>
                                        <input pInputText type="email" class="form-control" [value]="CM_email"
                                            formControlName="email" placeholder="Enter Email / மின்னஞ்சல்">

                                    </div>
                                    <div class="col-sm-6">
                                        <label>WhatsApp Number/வாட்ஸ்அப் எண் <span class="required "> *</span></label>
                                        <input pInputText type="text" class="form-control" formControlName="number"
                                            [value]="CM_number" placeholder="Enter WhatsApp Number/வாட்ஸ்அப் எண்"
                                            required />

                                    </div>
                                </div>

                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Academic Details/கல்வித் தகுதி <span class="required ">
                                                *</span></label>
                                        <input pInputText type="text" class="form-control" [value]="CM_education"
                                            formControlName="education"
                                            placeholder="Enter Academic Details/கல்வித் தகுதி">

                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Branch/கிளை <span class="required ">
                                                *</span></label>
                                        <input pInputText type="email" class="form-control" [value]="CM_branch"
                                            formControlName="branch" placeholder="Enter Branch/கிளை">

                                    </div>
                                </div>


                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>District / மாவட்டம்<span class="required ">
                                                *</span></label><br>
                                        <select class="form-control" formControlName="district" [(ngModel)]="district"
                                            #mydst (change)="getChangeToConstituey(mydst.value)">
                                            <option value="" selected disabled hidden>Select District</option>
                                            <option *ngFor="let option of district_list" [ngValue]="option">
                                                {{option}}</option>
                                        </select>

                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Constituency / தொகுதி<span class="required ">
                                                *</span></label>
                                        <select class="form-control" formControlName="constituency"
                                            [(ngModel)]="CM_constituency">
                                            <option value="" selected disabled>Select constituency</option>
                                            <option *ngFor="let option of user_constituency" [ngValue]="option">
                                                {{option}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Area of Expertise/நிபுணத்துவப் பகுதி <span class="required ">
                                                *</span></label>
                                        <input [value]="CM_area" pInputText type="text" class="form-control"
                                            formControlName="area"
                                            placeholder="Enter Area of Expertise/நிபுணத்துவப் பகுதி" required>
                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Courses Volunteering/படிப்புகள் தன்னார்வத் தொண்டு<span class="required ">
                                                *</span></label>
                                        <input readonly pInputText type="text" class="form-control" [value]="CM_courses"
                                            formControlName="courses"
                                            placeholder="Enter Courses Volunteering/படிப்புகள் தன்னார்வத் தொண்டு ">
                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Status/ சமுதாயப் படிநிலை <span class="required "> *</span></label>
                                        <select class="form-control" formControlName="status" required
                                            [(ngModel)]="CM_status">
                                            <option value="Active">Active</option>
                                            <option value="Inactive">Inactive</option>


                                        </select>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6 mb-3 mb-sm-0" *ngIf="CM_image !==''&& editfield">
                                        <label>Image <span class="required "> *</span></label>
                                        <img src="https://redmindtechnologies.com/dmk_php-dhanasekar/{{CM_image}}"
                                            style="width:100px;height:100px;display:block" />

                                    </div>
                                    <div class="col-md-6" *ngIf="editfield">
                                        <label>Photo<span class="required">*</span></label>
                                        <input type="file" class="form-control" formControlName="image"
                                            (change)="selectFiles($event)" />
                                    </div>
                                </div>



                                <div *ngIf="editfield" class="d-flex justify-content-center">
                                    <div style="width:200px">
                                        <button class="btn btn-danger btn btn-block">Update </button>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>